const copyLegacy = (text) => {
	console.log("called legacy copy with :>> ", text);
	return navigator.clipboard
		.writeText(text)
		.then(() => console.log("copy successful :>> ", text))
		.catch((err) => {
			console.log("copy failed :>> ", err);
		});
};

export default copyLegacy;
